export default __webpack_public_path__ + "static/media/roadmap-d-3.e676b558.png";